import { render, staticRenderFns } from "./WrongCollection.vue?vue&type=template&id=0d40f618&"
import script from "./WrongCollection.vue?vue&type=script&lang=js&"
export * from "./WrongCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports